import getSlug from 'speakingurl';
// Import helpers
import { getTypeTranslation } from 'helpers';

// add 'http://' or 'https://' at the beginning if it is absent
export const getBannerUrl = (url) => {
	if (!url.includes('http://') && !url.includes('https://')) {
		return (url = 'https://' + url);
	}
	return url;
};

// get link path for vod products
export const getVodUrl = ({ subtype, uuid, title }) => {
	const type = subtype === 'vod' ? 'movies' : subtype;
	const typeTranslated = getTypeTranslation(type);
	const slugTitle = getSlug(title);
	const vodLink = `/vod/${typeTranslated}/${uuid}/${slugTitle}`;
	return vodLink;
};
